<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>Q&A</h3>
                            <div class="h6 mt-4">
                                다옴토건에 자주 물어보시는 질문들을 볼 수 있는 공간입니다.
                            </div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <!-- 아코디언 -->
                            <div class="accordion" id="accordionExample">
                                <!-- 질문1 -->
                                <div class="card">
                                    <div class="card-header p-0" id="heading1">
                                        <h1 class="mb-0">
                                            <!-- <button class="btn btn-link btn-block text-left p-30" type="button" -->
                                            <button class="btn btn-link btn-block text-left p-30" type="button"
                                                data-toggle="collapse" data-target="#collapse1" aria-expanded="true"
                                                aria-controls="collapse1" style="white-space: normal;">
                                                Q. 시공은 들어가서 몇 일 정도에 끝나게 되나요?
                                            </button>
                                        </h1>
                                    </div>

                                    <div id="collapse1" class="collapse show" aria-labelledby="heading1"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            시공이 끝나는 기간은 공사 규모 및 종류에 따라 달라질 수 있으며 대체로 작은 규모의 경우 6개월 정도 걸립니다.
                                        </div>
                                    </div>
                                </div>
                                <!-- //질문1 -->
                                <!-- 질문2 -->
                                <div class="card">
                                    <div class="card-header p-0" id="heading2">
                                        <h1 class="mb-0">
                                            <button class="btn btn-link btn-block text-left p-30 collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapse2" aria-expanded="false"
                                                aria-controls="collapse2" style="white-space: normal;">
                                                Q. 시공비용은 어느 정도 들어갈까요?
                                            </button>
                                        </h1>
                                    </div>
                                    <div id="collapse2" class="collapse" aria-labelledby="heading2"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            비용의 경우 공사 종류에 따라 달라지며, 자세한 내용은 상담을 통해 안내 받으실 수 있습니다.
                                        </div>
                                    </div>
                                </div>
                                <!-- //질문2 -->
                                 <!-- 질문3 -->
                                <div class="card">
                                    <div class="card-header p-0" id="heading3">
                                        <h1 class="mb-0">
                                            <button class="btn btn-link btn-block text-left p-30 collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapse3" aria-expanded="false"
                                                aria-controls="collapse3" style="white-space: normal;">
                                                Q. 공사 재료비는 저희가 부담해야하나요?
                                            </button>
                                        </h1>
                                    </div>
                                    <div id="collapse3" class="collapse" aria-labelledby="heading3"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            공사 재료비는 견적과 함께 받으실 수 있으며 계약비 안에 포함되어 있습니다.
                                        </div>
                                    </div>
                                </div>
                                <!-- //질문3 -->
                                 <!-- 질문4 -->
                                <div class="card">
                                    <div class="card-header p-0" id="heading4">
                                        <h1 class="mb-0">
                                            <button class="btn btn-link btn-block text-left p-30 collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapse4" aria-expanded="false"
                                                aria-controls="collapse4" style="white-space: normal;">
                                                Q. 공사 중 추가로 확장을 원하면 어떻게 해야하나요?
                                            </button>
                                        </h1>
                                    </div>
                                    <div id="collapse4" class="collapse" aria-labelledby="heading4"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            이미 공사 중인 건에 대해서 마무리가 지어지거나 동시에 해야하는 작업인 경우 별도로 상담을 통해 진행 가능 합니다.
                                        </div>
                                    </div>
                                </div>
                                <!-- //질문4 -->
                                 <!-- 질문5 -->
                                <div class="card">
                                    <div class="card-header p-0" id="heading5">
                                        <h1 class="mb-0">
                                            <button class="btn btn-link btn-block text-left p-30 collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapse5" aria-expanded="false"
                                                aria-controls="collapse5" style="white-space: normal;">
                                                Q. 공사 중 발생하는 추가요금이 있을까요?
                                            </button>
                                        </h1>
                                    </div>
                                    <div id="collapse5" class="collapse" aria-labelledby="heading5"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            공사 도중 급변하는 재료비 등은 계약비 안에 포함되어 있기 때문에 추가로 발생하는 요금은 없습니다.
                                        </div>
                                    </div>
                                </div>
                                <!-- //질문5 -->
                            </div>
                            <!-- //아코디언 -->
                            <div class="mt-5 py-5 border-top">
                            <div class="text-center mt-5">
                                <h4>원하시는 내용이 없으시다면 아래 1:1 문의하기를 이용해보세요.</h4>
                                <br>
                                <base-button tag="a" href="/customer" type="warning" class="mt-4">
                                    1:1 문의하기
                                </base-button>
                            </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
import Jquery from '@/components/utills/jquery.min.js'
import Bootstrap from '@/components/utills/bootstrap.bundle.min.js'

export default {
    name: 'QandA',
    components: {
        Jquery,
        Bootstrap
    },
    data() {
        return {
        }
    },
    mounted() {

    }
};
</script>
<style>
.p-30{
    padding: 30px;
    font-size: large;
    font-weight: 600;
    color: black;
}
</style>
